import { render } from "./BusStopInfo.vue?vue&type=template&id=5cb89e84&ts=true"
import script from "./BusStopInfo.vue?vue&type=script&lang=ts"
export * from "./BusStopInfo.vue?vue&type=script&lang=ts"

import "./BusStopInfo.vue?vue&type=style&index=0&id=5cb89e84&lang=scss"

import exportComponent from "/Users/phoebe/projects/find-bus-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__